module.exports = __webpack_public_path__ + "static/virego_main_3-0c49aa60783187497e1ec1f9105b4cdd.png";